import { useMemo } from 'react';
import { ReturnItem } from 'services/api/refund';

export interface UseLazadaReturnOpsReturn {
  showMultipleCheck: boolean;
  hasOpsBtn: boolean;
  confirmDisabled: boolean;
  confirmReturnRefundDisabled: boolean;
  refuseDisabled: boolean;
}

export const useLazadaReturnOps = (returnItemData: ReturnItem[], platform: General.Platform) => {
  const { canConfirm, canConfirmReturnRefund, canRefuse } = useMemo(() => {
    if (platform !== 'lazada') {
      return {
        canConfirm: false,
        canConfirmReturnRefund: false,
        canRefuse: false,
      } as const;
    }

    let confirm = false;
    let confirmReturnRefund = false;
    let refuse = false;
    returnItemData.forEach((i) => {
      const operate = i.operate || [];
      if (operate.includes('CONFIRM')) {
        confirm = true;
      }
      if (operate.includes('CONFIRM_RETURN_REFUND')) {
        confirmReturnRefund = true;
      }
      if (operate.includes('REFUSE')) {
        refuse = true;
      }
    });
    return {
      canConfirm: confirm,
      canConfirmReturnRefund: confirmReturnRefund,
      canRefuse: refuse,
    } as const;
  }, [returnItemData, platform]);

  const hasOpsBtn = useMemo(() => {
    return canConfirm || canConfirmReturnRefund || canRefuse;
  }, [canConfirm, canConfirmReturnRefund, canRefuse]);

  const showMultipleCheck = useMemo(() => {
    const hasMultiple = returnItemData.length > 1;
    return hasMultiple && hasOpsBtn;
  }, [hasOpsBtn, returnItemData.length]);

  return {
    showMultipleCheck,
    hasOpsBtn,
    confirmDisabled: !canConfirm,
    confirmReturnRefundDisabled: !canConfirmReturnRefund,
    refuseDisabled: !canRefuse,
  } as const;
};
